import React from "react";
import PropTypes from "prop-types";

const DeleteCoupon = ({ deleteCoupon, deleteCouponID, handleDeleteCoupon }) => {
  const handleDeleteCouponByID = (e) => {
    e.preventDefault();
    deleteCoupon(deleteCouponID);
  };
  return (
    <div className="fixed left-0 top-0 z-50 flex size-full items-start justify-center border-grey-DDDFDE bg-black-00000050">
      <form className="relative mt-10 w-437px rounded-lg bg-white px-6 pt-23px">
        <div className="flex flex-col">
          <div className="font-MontserratSemiBold text-ft22-26.82-0.4 text-black-20">
            Confirm Deletion
          </div>
          <div className="mt-11px font-MontserratMedium text-ft15-26.25 text-black-000000">
            Are you sure you want to delete the selected coupon? This action is
            irreversible; click &quot;Delete&quot; to confirm or
            &quot;Cancel&quot; to retain the coupon.
          </div>

          <div className="mb-7.5 mt-6.5 flex justify-between">
            <div>
              <button
                onClick={handleDeleteCoupon}
                type="button"
                className="h-12 w-183px rounded border border-grey-D9D9D9"
              >
                <span className="font-MontserratMedium text-ft15-26.25 text-black-000000">
                  Cancel
                </span>
              </button>
            </div>
            <div>
              <button
                onClick={handleDeleteCouponByID}
                type="submit"
                className="h-12 w-183px rounded border border-grey-D9D9D9 bg-purple-6C36B0 text-white"
              >
                <span className="font-MontserratMedium text-ft15-26.25">
                  Confirm
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
DeleteCoupon.propTypes = {
  deleteCoupon: PropTypes.func.isRequired,
  deleteCouponID: PropTypes.string.isRequired,
  handleDeleteCoupon: PropTypes.func.isRequired
};
export default DeleteCoupon;
